import React from "react";

export function SearchIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="#999"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 19l-3.5-3.5m2.5-6a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
            ></path>
        </svg>
    );
}

export function SearchShortcutIconMac() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="43"
            height="21"
            fill="none"
            viewBox="0 0 43 21"
        >
            <rect width="43" height="21" fill="#F2F2F2" rx="5"></rect>
            <path
                stroke="#868686"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M9.5 9V7.5A1.5 1.5 0 108 9h1.5zm0 0v3m0-3h3m-3 3v1.5A1.5 1.5 0 118 12h1.5zm0 0h3m0 0H14a1.5 1.5 0 11-1.5 1.5V12zm0 0V9m0 0V7.5A1.5 1.5 0 1114 9h-1.5z"
            ></path>
            <path
                fill="#868686"
                d="M26.18 5.864l-2.812 10.448H22.23l2.813-10.448h1.137zM30.443 15V6.273h1.58v4.01h.107l3.405-4.01h1.93l-3.374 3.916L37.495 15h-1.9l-2.604-3.742-.967 1.143V15h-1.581z"
            ></path>
        </svg>
    );
}

export function SearchShortcutIconWin() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51"
            height="21"
            fill="none"
            viewBox="0 0 51 21"
        >
            <rect width="51" height="21" fill="#F2F2F2" rx="5"></rect>
            <path
                fill="#868686"
                d="M13.331 9.217h-1.594a1.982 1.982 0 00-.251-.694 1.87 1.87 0 00-1.078-.84 2.427 2.427 0 00-.746-.11c-.475 0-.895.119-1.261.357-.367.236-.654.583-.861 1.04-.208.455-.311 1.01-.311 1.666 0 .668.103 1.23.31 1.688.211.454.498.798.862 1.031.366.23.785.345 1.257.345.261 0 .505-.034.733-.102.23-.071.436-.175.617-.311a1.898 1.898 0 00.729-1.185l1.594.009c-.06.415-.189.804-.388 1.167a3.442 3.442 0 01-.771.963c-.318.276-.69.492-1.117.648-.426.154-.899.23-1.419.23-.767 0-1.451-.177-2.054-.532-.602-.355-1.076-.868-1.423-1.539-.346-.67-.52-1.474-.52-2.412 0-.94.175-1.744.524-2.412.35-.67.826-1.183 1.428-1.538s1.284-.533 2.045-.533c.486 0 .938.069 1.356.205.417.136.79.337 1.116.6.327.262.595.583.805.964.213.378.353.81.418 1.295zm4.648-.762v1.193h-3.763V8.455h3.763zm-2.834-1.569h1.543v6.145c0 .208.031.367.094.477.065.109.15.182.255.222a.98.98 0 00.35.06c.096 0 .184-.007.264-.021.082-.015.145-.027.187-.039l.26 1.206a2.897 2.897 0 01-.908.153 2.515 2.515 0 01-1.043-.174 1.625 1.625 0 01-.738-.605c-.179-.273-.267-.614-.264-1.023v-6.4zM19.27 15V8.455h1.496v1.09h.068c.12-.377.324-.669.614-.873a1.69 1.69 0 011.001-.311c.085 0 .18.004.286.013.108.005.197.015.268.03v1.418a1.622 1.622 0 00-.31-.06c-.14-.02-.275-.029-.406-.029a1.56 1.56 0 00-.758.183 1.34 1.34 0 00-.524.499 1.404 1.404 0 00-.192.737V15h-1.543zm6.3-8.727V15h-1.542V6.273h1.543zm7.951-.41l-2.812 10.45H29.57l2.813-10.45h1.137zM37.783 15V6.273h1.58v4.01h.107l3.405-4.01h1.93l-3.375 3.916L44.835 15h-1.9l-2.604-3.742-.967 1.143V15h-1.581z"
            ></path>
        </svg>
    );
}

export function TemplateIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            fill="none"
            viewBox="0 0 19 19"
        >
            <path
                stroke="#505F7B"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M8.225 16.215V2.785C8.225 1.51 7.681 1 6.33 1H2.896C1.544 1 1 1.51 1 2.785v13.43C1 17.49 1.544 18 2.896 18H6.33c1.351 0 1.895-.51 1.895-1.785zM18 8.565v-5.78C18 1.51 17.456 1 16.104 1H12.67c-1.351 0-1.895.51-1.895 1.785v5.78c0 1.275.544 1.785 1.895 1.785h3.434c1.352 0 1.896-.51 1.896-1.785zM18 16.215v-1.53c0-1.275-.544-1.785-1.896-1.785H12.67c-1.351 0-1.895.51-1.895 1.785v1.53c0 1.275.544 1.785 1.895 1.785h3.434C17.456 18 18 17.49 18 16.215z"
            ></path>
        </svg>
    );
}
